/*@flow*/
import styled from '@emotion/styled';

export default (styled.div(
  props => `
  padding: 0 10px 2px;
  border-bottom: solid 1px #ccc !important;
  display: grid;
  grid-template-columns: 50px 1fr;
  align-items: center;
  min-height: 4.2rem;
  grid-gap: 10px;

  & > span:first-of-type {
    font-size: 1rem;
    text-transform: uppercase;
    font-weight: bold;
    text-align: right;
  }

  ${props.styles || ''}
  ${props.disabled ? 'color: #6c757d !important;' : ''}
`
): any);
